//#region IMPORT
import React from 'react';
import {
  Unstable_Grid2 as Grid,
  Button as MuiButton,
  Stack,
  Box,
  TextField,
  Typography,
  Slide,
  ToggleButtonGroup,
  ToggleButton,
  styled,
  toggleButtonGroupClasses,
  toggleButtonClasses,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  Chip,
  IconButton,
  Fade,
  Divider,
  Alert,
} from '@mui/material';
import {
  Save as SaveIcon,
  AttachFile as AttachFileIcon,
  CloudUpload as CloudUploadIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Devices as DevicesIcon,
  Computer as ComputerIcon,
  Smartphone as SmartphoneIcon,
  Campaign as CampaignIcon,
} from '@mui/icons-material';
import {
  AuthButton,
  Combo,
  DatePicker,
  Dialog,
  MultiChipSelect,
} from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import { useDropzone } from 'react-dropzone';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Icon from '../../../../Assets/Icon/CustomIcons';
import Global from '../../../../Services/Common/Global';
import { useNavigate } from 'react-router-dom';
//#endregion

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// 스타일 컴포넌트
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  gap: '1rem',
  [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]:
    {
      borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
      borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
    },
  [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]:
    {
      borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
      borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
      borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`,
    },
  [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]:
    {
      borderLeft: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`,
    },
}));

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  fontSize: '15px',
  fontWeight: '600',
  padding: '10px 28px',
  textTransform: 'none',
  border: '2px solid #e0e0e0',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    borderColor: '#4e4caf',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(78, 76, 175, 0.15)',
  },
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#4e4caf',
    border: '2px solid #4e4caf',
    '&:hover': {
      backgroundColor: '#3d3b8f',
      borderColor: '#3d3b8f',
    },
  },
}));

const ChannelToggleButton = styled(ToggleButton)(({ theme }) => ({
  flex: 1,
  minWidth: 120,
  fontSize: '14px',
  fontWeight: '600',
  padding: '12px 16px',
  textTransform: 'none',
  border: '2px solid #e8eaf0',
  borderRadius: '12px !important',
  gap: theme.spacing(0.75),
  transition: 'all 0.25s ease',
  '&:hover': {
    backgroundColor: '#f0f7ff',
    borderColor: '#1976d2',
    transform: 'translateY(-1px)',
  },
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#1976d2',
    border: '2px solid #1976d2',
    boxShadow: '0 4px 14px rgba(25, 118, 210, 0.35)',
    '&:hover': {
      backgroundColor: '#1565c0',
    },
  },
}));

const SectionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
  },
}));

const SectionLabel = styled(Typography)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '16px',
  color: '#333',
  minWidth: '110px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const FileChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  padding: theme.spacing(1),
  height: 'auto',
  '& .MuiChip-label': {
    padding: theme.spacing(1, 1.5),
    fontSize: '14px',
  },
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'scale(1.02)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
}));

const RequiredDot = styled('span')({
  color: '#d32f2f',
  fontSize: '20px',
  marginLeft: '4px',
});

function NOT_BASIC_01_02(props) {
  const navigate = useNavigate();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: true,
    onDrop: async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      const fakeEvent = {
        target: { files: acceptedFiles, value: '' },
      };

      await props.FileChange(fakeEvent);
    },
  });

  const needsDeptSite =
    props.inputs.gubun === '2' &&
    ['ADMIN', 'BUSINESS_OWNER'].includes(props.userInfo?.authCd);

  const wholeNoticeHint =
    props.userInfo?.authCd === 'HEAD_MANAGER'
      ? '✓ 전체 부서에 적용됩니다'
      : props.userInfo?.authCd === 'BUSINESS_OWNER'
        ? '✓ 소속 회사 전체에 적용됩니다'
        : props.userInfo?.authCd === 'ADMIN'
          ? '✓ 선택한 회사 전체에 적용됩니다'
          : '✓ 전체 사업장에 적용됩니다';

  const isFormValid =
    props.inputs.title?.trim() &&
    props.inputs.comment?.trim() &&
    (props.inputs.gubun === '0' ||
      (needsDeptSite
        ? props.selectedCustForDept && props.selectedGjs?.length > 0
        : props.selectedGjs?.length > 0));

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Notice2"
          searchBox="N"
          addYn="N"
          printYn="N"
          saveYn="N"
          deleteYn="N"
          buttonsSx={{
            backgroundColor: 'transparent',
          }}
          gridStyle={{
            height: '100%',
          }}
          conditions={[
            {
              type: 'other',
              item: (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    pb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: '800',
                      fontSize: '24px',
                      color: '#1a1a1a',
                      letterSpacing: '-0.5px',
                    }}
                  >
                    새 글 쓰기
                  </Typography>
                  {isFormValid && (
                    <Fade in={isFormValid}>
                      <Chip
                        icon={<CheckCircleIcon />}
                        label="작성 완료"
                        color="success"
                        size="small"
                        sx={{ fontWeight: '600' }}
                      />
                    </Fade>
                  )}
                </Box>
              ),
            },
          ]}
          grids={
            <Stack
              spacing={3}
              sx={{
                py: 4,
                px: { xs: 2, sm: 4, md: 8 },
                height: '100%',
                backgroundColor: '#fafafa',
                borderRadius: 5,
                overflowY: 'auto',
              }}
            >
              {/* ADMIN: 공지 중요도 + 게시 환경 */}
              {props.userInfo.authCd === 'ADMIN' && (
                <Fade in timeout={300}>
                  <SectionCard elevation={0}>
                    <Stack spacing={2.5}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{ mb: 0.5 }}
                      >
                        <CampaignIcon sx={{ color: '#4e4caf', fontSize: 22 }} />
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: '17px',
                            color: '#333',
                          }}
                        >
                          공지 설정
                        </Typography>
                        <Chip
                          label="시스템 관리자"
                          size="small"
                          sx={{
                            ml: 1,
                            fontWeight: 600,
                            bgcolor: '#ede7f6',
                            color: '#4e4caf',
                          }}
                        />
                      </Stack>

                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 4 }}
                        alignItems={{ sm: 'flex-start' }}
                      >
                        <Stack spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
                          <SectionLabel>
                            공지 유형
                            <RequiredDot>*</RequiredDot>
                          </SectionLabel>
                          <StyledToggleButtonGroup
                            value={props.inputs.noticeYn || 'N'}
                            exclusive
                            onChange={(e, newValue) => {
                              if (newValue == null) return;
                              props.setInputs({
                                ...props.inputs,
                                noticeYn: newValue,
                              });
                            }}
                            aria-label="notice importance"
                            sx={{ flexWrap: 'wrap' }}
                          >
                            <CustomToggleButton value="N">
                              기본 공지
                            </CustomToggleButton>
                            <CustomToggleButton value="Y">
                              중요 공지
                            </CustomToggleButton>
                          </StyledToggleButtonGroup>
                        </Stack>

                        <Stack spacing={1.5} sx={{ flex: 1.2, minWidth: 0 }}>
                          <SectionLabel>
                            게시 환경
                            <RequiredDot>*</RequiredDot>
                          </SectionLabel>
                          <StyledToggleButtonGroup
                            value={String(props.inputs.noticeType ?? '0')}
                            exclusive
                            onChange={(e, newValue) => {
                              if (newValue == null) return;
                              props.setInputs({
                                ...props.inputs,
                                noticeType: newValue,
                              });
                            }}
                            aria-label="notice exposure channel"
                            sx={{
                              width: '100%',
                              display: 'flex',
                              gap: 1,
                              '& .MuiToggleButtonGroup-grouped': {
                                flex: 1,
                                border: 0,
                                borderRadius: '12px !important',
                              },
                            }}
                          >
                            <ChannelToggleButton value="0">
                              <DevicesIcon sx={{ fontSize: 20 }} />웹 / 앱
                            </ChannelToggleButton>
                            <ChannelToggleButton value="1">
                              <ComputerIcon sx={{ fontSize: 20 }} />웹
                            </ChannelToggleButton>
                            <ChannelToggleButton value="2">
                              <SmartphoneIcon sx={{ fontSize: 20 }} />앱
                            </ChannelToggleButton>
                          </StyledToggleButtonGroup>
                        </Stack>
                      </Stack>
                    </Stack>
                  </SectionCard>
                </Fade>
              )}

              {/* 대상 선택 */}

              <Fade in timeout={400}>
                <SectionCard elevation={0}>
                  <Stack spacing={3}>
                    <SectionLabel>
                      대상 선택
                      <RequiredDot>*</RequiredDot>
                    </SectionLabel>

                    <Stack
                      spacing={2}
                      direction={{ xs: 'column', md: 'row' }}
                      sx={{ width: '100%' }}
                    >
                      {props.userInfo.authCd === 'ADMIN' && (
                        <Box sx={{ flex: 1, minWidth: 200 }}>
                          <Combo
                            fullWidth
                            size="small"
                            name="회사"
                            items={props.coList}
                            value={props.selectedCo}
                            onChange={(e) => props.handleCoChange(e)}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 250,
                                  overflowY: 'auto',
                                },
                              },
                            }}
                            sx={{
                              fontSize: '16px',
                              '& .MuiOutlinedInput-root': {
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                },
                              },
                            }}
                          />
                        </Box>
                      )}

                      <Box sx={{ flex: 1, minWidth: 200 }}>
                        <Combo
                          fullWidth
                          size="small"
                          items={props.comboData}
                          value={props.inputs.gubun}
                          name={'구분'}
                          onChange={(e) => {
                            if (props.userInfo.authCd === 'ADMIN') {
                              props.HandleGubunChange(e);
                            } else {
                              props.setInputs({
                                ...props.inputs,
                                gubunDtl: '',
                                gubunDtlNm: '',
                                gubun: e,
                              });
                              props.setSelectedGjs([]);
                              props.HandleGubunChange(e);
                            }
                          }}
                          sx={{
                            fontSize: '16px',
                            '& .MuiOutlinedInput-root': {
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                              },
                            },
                          }}
                        />
                      </Box>

                      {props.inputs.gubun === '0' ? (
                        <Box
                          sx={{
                            flex: 2,
                            minWidth: 300,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#e3f2fd',
                            borderRadius: '8px',
                            border: '2px solid #2196f3',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#1565c0',
                              fontWeight: '600',
                              fontSize: '15px',
                            }}
                          >
                            {wholeNoticeHint}
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            flex: 2,
                            minWidth: 300,
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            gap: 2,
                            alignItems: 'stretch',
                          }}
                        >
                          {needsDeptSite && (
                            <Box sx={{ flex: 1, minWidth: 180 }}>
                              <Combo
                                fullWidth
                                size="small"
                                name="사업장"
                                items={props.custListForDept}
                                value={props.selectedCustForDept}
                                onChange={(e) => props.handleDeptSiteChange(e)}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 250,
                                      overflowY: 'auto',
                                    },
                                  },
                                }}
                                sx={{
                                  fontSize: '16px',
                                  '& .MuiOutlinedInput-root': {
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    },
                                  },
                                }}
                              />
                            </Box>
                          )}
                          <Box sx={{ flex: 2, minWidth: 200 }}>
                            <MultiChipSelect
                              fullWidth
                              items={props.gubunDtlData}
                              value={props.selectedGjs}
                              onChange={props.HandleGJChange}
                              disabled={
                                props.inputs.gubun !== '0' && props.isDisabled
                              }
                              label={'구분 상세'}
                              sx={{
                                fontSize: '16px',
                                '& .MuiOutlinedInput-root': {
                                  transition: 'all 0.3s ease',
                                  '&:hover': {
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  },
                                },
                              }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 250,
                                    overflowY: 'auto',
                                  },
                                },
                              }}
                              onClick={props.HandleGJClick}
                            />
                          </Box>
                        </Box>
                      )}
                    </Stack>

                    {props.selectedGjs?.length === 0 &&
                      props.inputs.gubun !== '0' && (
                        <Alert severity="warning" sx={{ mt: 1 }}>
                          대상을 선택해주세요
                        </Alert>
                      )}
                  </Stack>
                </SectionCard>
              </Fade>

              {/* 공지 정보 */}
              <Fade in timeout={500}>
                <SectionCard elevation={0}>
                  <Stack spacing={3}>
                    <SectionLabel>
                      공지 정보
                      <RequiredDot>*</RequiredDot>
                    </SectionLabel>

                    <Stack
                      spacing={2}
                      direction={{ xs: 'column', md: 'row' }}
                      sx={{ alignItems: 'flex-start' }}
                    >
                      <TextField
                        fullWidth
                        required
                        error={
                          !props.inputs.title ||
                          props.inputs.title.trim() === ''
                        }
                        helperText={
                          !props.inputs.title ||
                          props.inputs.title.trim().length === 0
                            ? '필수 입력 항목입니다.'
                            : ''
                        }
                        label={'제목'}
                        placeholder="공지사항 제목을 입력하세요"
                        sx={{
                          flex: 3,
                          '& .MuiOutlinedInput-root': {
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            },
                            '& fieldset': {
                              borderWidth: '2px',
                              borderColor:
                                props.inputs.title &&
                                props.inputs.title.trim() !== ''
                                  ? '#4caf50'
                                  : '#f44336',
                            },
                            '&:hover fieldset': {
                              borderColor:
                                props.inputs.title &&
                                props.inputs.title.trim() !== ''
                                  ? '#4caf50'
                                  : '#f44336',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor:
                                props.inputs.title &&
                                props.inputs.title.trim() !== ''
                                  ? '#4caf50'
                                  : '#f44336',
                            },
                          },
                        }}
                        inputProps={{ maxLength: 100 }}
                        value={props.inputs.title}
                        onChange={(e) => {
                          let noEmojiInput = e.target.value.replace(
                            /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
                            ''
                          );
                          props.setInputs({
                            ...props.inputs,
                            title: noEmojiInput,
                          });
                        }}
                      />

                      <Box sx={{ flex: 1, minWidth: 200 }}>
                        <DatePicker
                          name={'공지 종료일'}
                          format="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              size: 'medium',
                              fullWidth: true,
                              InputProps: {
                                sx: {
                                  fontSize: '16px',
                                  transition: 'all 0.3s ease',
                                  '&:hover': {
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                  },
                                },
                              },
                            },
                          }}
                          value={dayjs(props.inputs.endDate)}
                          onChange={(date) => {
                            let changeDate = dayjs(date).format('YYYY-MM-DD');
                            if (date) {
                              props.setInputs({
                                ...props.inputs,
                                endDate: changeDate,
                              });
                            }
                          }}
                        />
                      </Box>
                    </Stack>
                  </Stack>
                </SectionCard>
              </Fade>

              {/* 첨부 자료 */}
              <Fade in timeout={600}>
                <SectionCard elevation={0}>
                  <Stack spacing={2}>
                    <SectionLabel>
                      <AttachFileIcon sx={{ fontSize: 20 }} />
                      첨부 자료
                    </SectionLabel>

                    <Box
                      {...getRootProps()}
                      sx={{
                        width: '100%',
                        border: isDragActive
                          ? '3px dashed #4e4caf'
                          : '2px dashed #ccc',
                        borderRadius: '12px',
                        p: 4,
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: isDragActive
                          ? 'rgba(78, 76, 175, 0.05)'
                          : 'transparent',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          borderColor: '#4e4caf',
                          backgroundColor: 'rgba(78, 76, 175, 0.03)',
                          transform: 'scale(1.01)',
                        },
                      }}
                    >
                      <input {...getInputProps()} />
                      <CloudUploadIcon
                        sx={{
                          fontSize: 48,
                          color: isDragActive ? '#4e4caf' : '#bbb',
                          mb: 2,
                        }}
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          color: isDragActive ? '#4e4caf' : '#666',
                          fontWeight: '600',
                        }}
                      >
                        {isDragActive
                          ? '파일을 여기에 놓으세요'
                          : '파일을 끌어오거나 클릭하여 선택하세요'}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: '#999', mt: 1 }}
                      >
                        여러 파일을 동시에 업로드할 수 있습니다
                      </Typography>
                    </Box>

                    {props.uploadedFiles?.length > 0 && (
                      <Box sx={{ mt: 2 }}>
                        <Divider sx={{ mb: 2 }} />
                        <Typography
                          variant="subtitle2"
                          sx={{
                            color: '#666',
                            mb: 1,
                            fontWeight: '600',
                          }}
                        >
                          업로드된 파일 (
                          {props.uploadedFiles.filter((f) => !f.deleted).length}
                          개)
                        </Typography>

                        {/* ✅ 일반 파일 섹션 */}
                        {props.uploadedFiles.some(
                          (f) =>
                            !f.deleted &&
                            !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                              f.fileName || ''
                            )
                        ) && (
                          <Box sx={{ mt: 2 }}>
                            <Box
                              sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1,
                              }}
                            >
                              {props.uploadedFiles
                                .filter(
                                  (f) =>
                                    !f.deleted &&
                                    !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                      f.fileName || ''
                                    )
                                )
                                .map((item, index) => (
                                  <Box
                                    key={index}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 0.5,
                                    }}
                                  >
                                    <FileChip
                                      icon={<AttachFileIcon />}
                                      label={item.fileName}
                                      // onClick={() => {
                                      //   props.DownloadLogic2(item);
                                      // }}
                                      onDelete={() => props.DeletePreview(item)}
                                      color="primary"
                                      variant="outlined"
                                      sx={{
                                        cursor: 'pointer',
                                        '&:hover': {
                                          backgroundColor:
                                            'rgba(78, 76, 175, 0.08)',
                                          '& .MuiChip-label': {
                                            textDecoration: 'underline',
                                          },
                                        },
                                      }}
                                    />
                                  </Box>
                                ))}
                            </Box>
                          </Box>
                        )}

                        {/* ✅ 이미지 파일 섹션 */}
                        {props.uploadedFiles.some(
                          (f) =>
                            !f.deleted &&
                            /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                              f.fileName || ''
                            )
                        ) && (
                          <Box sx={{ my: 2 }}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 600, color: '#555', mb: 1 }}
                            >
                              이미지 미리보기
                            </Typography>
                            <Box
                              sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1,
                              }}
                            >
                              {props.uploadedFiles
                                .filter(
                                  (f) =>
                                    !f.deleted &&
                                    /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                      f.fileName || ''
                                    )
                                )
                                .map((item, index) => (
                                  <Box
                                    key={index}
                                    sx={{
                                      position: 'relative',
                                      width: '90px',
                                      height: '92px',
                                      border: '1px solid #DFD9D9',
                                      borderRadius: '8px',
                                      overflow: 'hidden',
                                      '&:hover .download-button': {
                                        opacity: 1,
                                      },
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                      }}
                                      src={
                                        item.filePath
                                          ? `${Global.file.useUrl}files/${item.filePath}`
                                          : item.preview
                                      }
                                      alt={item.fileName}
                                    />
                                    {/* <IconButton
                                      className="download-button"
                                      sx={{
                                        position: 'absolute',
                                        bottom: 4,
                                        left: 4,
                                        padding: '4px',
                                        backgroundColor:
                                          'rgba(255, 255, 255, 0.9)',
                                        opacity: 0,
                                        transition: 'opacity 0.2s',
                                        '&:hover': {
                                          backgroundColor:
                                            'rgba(255, 255, 255, 1)',
                                        },
                                      }}
                                      size="small"
                                      onClick={() => props.DownloadLogic2(item)}
                                    >
                                      <DownloadIcon sx={{ fontSize: 16 }} />
                                    </IconButton> */}
                                    <IconButton
                                      sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        padding: '4px',
                                        backgroundColor:
                                          'rgba(255, 255, 255, 0.8)',
                                        '&:hover': {
                                          backgroundColor:
                                            'rgba(255, 255, 255, 0.95)',
                                        },
                                      }}
                                      size="small"
                                      onClick={() => props.DeletePreview(item)}
                                    >
                                      <Icon.Delete2 sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Box>
                                ))}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Stack>
                </SectionCard>
              </Fade>

              {/* 공지 내용 */}
              <Fade in timeout={700}>
                <SectionCard elevation={0}>
                  <Stack spacing={2}>
                    <SectionLabel>
                      공지 내용
                      <RequiredDot>*</RequiredDot>
                    </SectionLabel>

                    <SunEditor
                      height="300px"
                      setOptions={{
                        buttonList: [
                          ['undo', 'redo'],
                          ['bold', 'underline', 'italic', 'strike'],
                          ['fontColor', 'hiliteColor', 'align', 'list'],
                          ['link'],
                          ['removeFormat'],
                        ],
                        placeholder: '공지사항 내용을 입력하세요 (최대 1000자)',
                        charCounter: true,
                        charCounterType: 'byte', // 글자수 표시는 직접 구현할 예정이라 비활성 가능
                        defaultStyle: 'font-size: 15px; line-height: 1.6;',
                      }}
                      setContents={props.inputs.comment || ''}
                      onChange={(content) => {
                        const plainText = content
                          .replace(/<[^>]*>?/gm, '')
                          .replace(
                            /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
                            ''
                          );

                        if (plainText.length <= 1000) {
                          props.setInputs((prev) => ({
                            ...prev,
                            comment: content,
                          }));
                        } else {
                          props.dispatch(
                            props.showSnackbar({
                              message: `공지사항은 1000자까지 입력 가능합니다.`,
                              type: 'warning',
                            })
                          );
                        }
                      }}
                    />

                    {/* 글자수 카운터 영역 */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: 1,
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          color:
                            (props.inputs.comment?.replace(/<[^>]*>?/gm, '')
                              .length || 0) > 900
                              ? '#f44336'
                              : '#999',
                          fontWeight: '600',
                        }}
                      >
                        {(props.inputs.comment?.replace(/<[^>]*>?/gm, '')
                          .length || 0) > 900 &&
                          '⚠️ 글자 수가 거의 다 찼습니다'}
                      </Typography>

                      <Typography
                        sx={{
                          color:
                            (props.inputs.comment?.replace(/<[^>]*>?/gm, '')
                              .length || 0) >= 1000
                              ? '#f44336'
                              : '#666',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}
                      >
                        {props.inputs.comment?.replace(/<[^>]*>?/gm, '')
                          .length || 0}{' '}
                        / 1000 자
                      </Typography>
                    </Box>
                  </Stack>
                </SectionCard>
              </Fade>

              {/* 공개 여부 */}
              {/* <Fade in timeout={800}>
                <SectionCard elevation={0}>
                  <Stack
                    spacing={3}
                    direction={{ xs: 'column', sm: 'row' }}
                    sx={{ alignItems: { xs: 'flex-start', sm: 'center' } }}
                  >
                    <SectionLabel>공개 여부</SectionLabel>
                    <RadioGroup
                      row
                      value={String(props.inputs.isPublic || '0')}
                      onChange={(e) =>
                        props.setInputs({
                          ...props.inputs,
                          isPublic: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        value="0"
                        control={
                          <Radio
                            size="medium"
                            sx={{
                              '&.Mui-checked': {
                                color: '#4e4caf',
                              },
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ fontWeight: '600' }}>
                            공개
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value="1"
                        control={
                          <Radio
                            size="medium"
                            sx={{
                              '&.Mui-checked': {
                                color: '#4e4caf',
                              },
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ fontWeight: '600' }}>
                            비공개
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </Stack>
                </SectionCard>
              </Fade> */}

              {/* 액션 버튼 */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 2,
                  mt: 4,
                  pb: 2,
                }}
              >
                {props.state && (
                  <MuiButton
                    sx={{
                      px: 4,
                      py: 1.5,
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#fff',
                      backgroundColor: '#d32f2f',
                      borderRadius: '12px',
                      textTransform: 'none',
                      boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#b71c1c',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 16px rgba(211, 47, 47, 0.4)',
                      },
                    }}
                    variant="contained"
                    startIcon={<CancelIcon />}
                    onClick={() => {
                      props.setDialogToggle1({
                        ...props.dialogToggle1,
                        open: true,
                        title: '',
                        content: [
                          <Box sx={{ width: '400px', p: 2 }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                              작성 중인 항목을 취소하시겠습니까?
                            </Typography>
                            <Alert severity="warning">
                              지금까지 작성된 내용은 저장되지 않습니다.
                            </Alert>
                          </Box>,
                        ],
                      });
                    }}
                  >
                    취소
                  </MuiButton>
                )}

                <MuiButton
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#fff',
                    backgroundColor: isFormValid ? '#2ca900' : '#ccc',
                    borderRadius: '12px',
                    textTransform: 'none',
                    boxShadow: isFormValid
                      ? '0 4px 12px rgba(44, 169, 0, 0.3)'
                      : 'none',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: isFormValid ? '#248a00' : '#ccc',
                      transform: isFormValid ? 'translateY(-2px)' : 'none',
                      boxShadow: isFormValid
                        ? '0 6px 16px rgba(44, 169, 0, 0.4)'
                        : 'none',
                    },
                    '&:disabled': {
                      backgroundColor: '#e0e0e0',
                      color: '#999',
                    },
                  }}
                  variant="contained"
                  startIcon={<SaveIcon />}
                  disabled={!isFormValid}
                  onClick={() => {
                    props.Save1();
                  }}
                >
                  저장
                </MuiButton>
              </Box>
            </Stack>
          }
        />
      </Grid>

      <Dialog
        sx={{ height: '100%' }}
        open={props.dialogToggle1.open}
        onClose={() => props.setDialogToggle1(false)}
        TransitionComponent={Transition}
        title={props.dialogToggle1.title}
        content={props.dialogToggle1.content}
        contentText={props.dialogToggle1.contentText}
        actions={props.dialogToggle1.actions}
        useSaveButton={true}
        useCloseButton={true}
        saveButtonName={'확인'}
        closeButtonName={'닫기'}
        onSave={() => {
          props.setInputs({});
          props.setUploadedFiles([]);
          // 페이지 이동
          navigate('/NoticeBoard');
        }}
      />
    </Grid>
  );
}

export default NOT_BASIC_01_02;
